module.exports = __webpack_public_path__ + "static/media/menu.bbd5c93e.svg";